import { useEffect, useState } from "react";
import { Globe2, MapPin } from "lucide-react";
import { Label } from "@/components/ui/label";
import { useAuth } from "@/context/AuthContext";
import { api } from "@/lib/api";

export function AudienceField({ value = [], onChange, testId = "audience" }) {
  const { user } = useAuth();
  const [regions, setRegions] = useState([]);
  const admin = user.role === "admin";
  useEffect(() => { api.get("/regions").then((r) => setRegions(r.data)); }, []);
  useEffect(() => {
    if (!admin && (value.length !== 1 || value[0] !== user.region_id)) onChange([user.region_id]);
  }, [admin, value, user.region_id, onChange]);
  const regional = value.length > 0;
  const own = regions.find((r) => r.id === user.region_id);
  return (
    <div className="space-y-2" data-testid={testId}>
      <Label>Audience</Label>
      {!admin ? (
        <p className="flex items-center gap-2 rounded-xl bg-lasso-tint px-3 py-2 text-sm" data-testid={`${testId}-fixed`}><MapPin className="h-4 w-4" /> Region-specific · {own?.name || "your region"}</p>
      ) : (
        <>
          <div className="flex gap-2">
            {[[false, "Company-wide", Globe2], [true, "Region-specific", MapPin]].map(([r, label, Icon]) => (
              <button key={label} type="button" onClick={() => onChange(r ? (regions[0] ? [regions[0].id] : []) : [])}
                className={`inline-flex items-center gap-1.5 rounded-full border px-3 py-1.5 text-xs font-semibold ${regional === r ? "border-lasso-ink bg-lasso-ink text-white" : "border-lasso-line"}`}
                data-testid={`${testId}-${r ? "regional" : "company"}`}><Icon className="h-3.5 w-3.5" />{label}</button>
            ))}
          </div>
          {regional && (
            <div className="flex flex-wrap gap-3">
              {regions.map((r) => (
                <label key={r.id} className="flex items-center gap-1.5 text-sm">
                  <input type="checkbox" checked={value.includes(r.id)} data-testid={`${testId}-region-${r.code}`}
                    onChange={() => { const n = value.includes(r.id) ? value.filter((x) => x !== r.id) : [...value, r.id]; onChange(n.length ? n : value); }} />
                  {r.name}
                </label>
              ))}
            </div>
          )}
        </>
      )}
    </div>
  );
}

export const AudienceBadge = ({ ids, regions }) => !ids?.length ? null : (
  <span className="inline-flex items-center gap-1 rounded-full bg-lasso-tint px-2 py-0.5 text-[10px] font-semibold text-lasso-deep" data-testid="audience-badge">
    <MapPin className="h-3 w-3" />{regions ? ids.map((i) => regions[i] || "Region").join(", ") : "Region-specific"}
  </span>
);
